import styled from "styled-components";

const StyledSingleVideo = styled.section`
	display: flex;

	.play-button {
		width: 0;
		height: 0;
		border-top: 60px solid transparent;
		border-bottom: 60px solid transparent;
		border-left: 80px solid #48bbcd;
		opacity: 0.2;
		transition: all 300ms ease;
		-webkit-transition: all 300ms ease;
	}

	.nextArrow {
		display: block;
		position: relative;
		float: right;
		width: 50px;
		height: 100px;
		background-color: #000;
	}

	.beforeArrow {
		display: block;
		position: relative;
		float: left;
		width: 50px;
		height: 100px;
		background-color: #000;
	}

	.thumb {
		height: 0;
		padding-bottom: 56%;
		width: 100%;
		background-color: transparent;
		background-repeat: no-repeat;
		background-size: cover;
		background-position: center;
		position: relative;
		border: 3px solid #48bbcd;
		box-shadow: 0px 4px 15px 0px rgba(0, 0, 0, 0.35);

		&:hover {
			cursor: pointer;

			.inner {
				h3 {
					/* opacity: 0; */
				}

				img,
				.play-button {
					transform: scale(1.3);
					opacity: 0.6;
				}
			}
		}
	}

	.thumb .inner {
		display: flex;
		flex-wrap: wrap;
		align-content: center;
		align-items: center;
		justify-content: center;
		width: 100%;
		height: 100%;
		position: absolute;
		top: 0;
		left: 0;
	}

	.thumb .inner img {
		position: absolute;
		z-index: 3;
		opacity: 0.5;
		transition: all 300ms ease;
		-webkit-transition: all 300ms ease;
	}

	.thumb .inner h3 {
		position: absolute;
		z-index: 4;
		color: #48bbcd;
		text-transform: uppercase;
		transition: opacity 300ms ease;
		-webkit-transition: opacity 300ms ease;
		text-shadow: 1px 1px rgba(0, 0, 0, 0.5);
		line-height: 1.3;
		font-weight: bold;
		margin: 0;
		display: block;
	}

	&.show-thumbnails {
		.thumb {
			.inner {
				align-items: flex-end;
				h3 {
					background-color: #48bbcd;
					padding: 5px 15px;
					font-weight: bold;
					/* box-shadow: rgba(0, 0, 0, 0.3) 0px 4px 10px; */
					font-size: 18px;
					width: 100%;
				}
			}
		}
	}
`;

export default StyledSingleVideo;
